import _classCallCheck from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import Effect from "./Effect";
import { FFT_TYPES } from "../Constants";

if (global.AnalyserNode && !global.AnalyserNode.prototype.getFloatTimeDomainData) {
  var uint8 = new Uint8Array(2048);

  global.AnalyserNode.prototype.getFloatTimeDomainData = function (array) {
    this.getByteTimeDomainData(uint8);

    for (var i = 0, imax = array.length; i < imax; i++) {
      array[i] = (uint8[i] - 128) * 0.0078125;
    }
  };
}

var FFT =
/*#__PURE__*/
function (_Effect) {
  _inherits(FFT, _Effect);

  function FFT(context) {
    var _this;

    _classCallCheck(this, FFT);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FFT).call(this, context));
    _this.name = "fft";
    _this.mode = FFT_TYPES.FREQUENCY;
    return _this;
  }

  _createClass(FFT, [{
    key: "setup",
    value: function setup() {
      this.canvas = document.createElement("canvas");
      this.canvas.setAttribute("id", "fft");
      this.ctx = this.canvas.getContext("2d");
      this.ctx.canvas.width = 512;
      this.ctx.canvas.height = 512;
      this.effect = this.context.createAnalyser();
      this.effect.fftSize = 2048;
      this.effect.maxDecibels = -50;
      this.effect.minDecibels = -120;
      this.effect.smoothingTimeConstant = 0.9;
      this.effect.connect(this.output);
    }
  }, {
    key: "data",
    value: function data() {
      switch (this.mode) {
        case FFT_TYPES.FREQUENCY:
          var myDataArray = new Float32Array(this.effect.frequencyBinCount);
          this.effect.getFloatFrequencyData(myDataArray);
          break;

        case FFT_TYPES.TIME:
          var myDataArray = new Float32Array(this.effect.frequencyBinCount);
          this.effect.getFloatTimeDomainData(myDataArray);
          break;

        case FFT_TYPES.FREQUENCY8:
          var myDataArray = new Uint8Array(this.effect.frequencyBinCount);
          this.effect.getByteFrequencyDomainData(myDataArray);
          break;

        case FFT_TYPES.TIME8:
          var myDataArray = new Uint8Array(this.effect.frequencyBinCount);
          this.effect.getByteTimeDomainData(myDataArray);
          break;
      }

      return myDataArray;
    }
  }, {
    key: "draw",
    value: function draw() {
      var _this2 = this;

      var myDataArray = this.data();
      var ctx = this.ctx;
      ctx.save(); //ctx.globalAlpha = 0.5;

      ctx.fillStyle = "rgb(33,33,99)";
      ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
      ctx.restore();
      var i = 0;
      var width = ctx.canvas.width / myDataArray.length;
      var height = ctx.canvas.height * 0.5;
      ctx.beginPath();
      ctx.moveTo(0, height);
      ctx.strokeStyle = "rgb(100,255,255)";
      ctx.lineWidth = 5;

      for (var point in myDataArray) {
        ctx.lineTo(width * i, height + myDataArray[point] * height * 10);
        i++;
      }

      ctx.moveTo(width, height);
      ctx.stroke();
      window.requestAnimationFrame(function () {
        _this2.draw();
      });
    }
  }, {
    key: "addToElement",
    value: function addToElement(element) {
      element.appendChild(this.element);
    }
  }, {
    key: "element",
    get: function get() {
      return this.canvas;
    }
  }], [{
    key: "FFT_TYPES",
    get: function get() {
      return FFT_TYPES;
    }
  }]);

  return FFT;
}(Effect);

export { FFT as default };